import { render, staticRenderFns } from "./IntegrationLogs.vue?vue&type=template&id=3dfa4152"
import script from "./IntegrationLogs.vue?vue&type=script&lang=js"
export * from "./IntegrationLogs.vue?vue&type=script&lang=js"
import style0 from "./IntegrationLogs.vue?vue&type=style&index=0&id=3dfa4152&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports